import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SCAMP_API } from 'src/environments/environment';
import { Security } from '../utils/security.util';

@Injectable({providedIn: 'root'})
export class AccountService {
    constructor(private http: HttpClient) {}

    public composeHeaders() {
        const token = Security.getToken();
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        return headers;
    }

    getHearderAuthorization() {
        return {
            "Authorization": `Bearer ${Security.getToken()}`
          }
    }

    authenticate(data) {
        const dt = 'grant_type=password&username=' + data.username + '&password=' + data.password;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
        return this.http.post(`${SCAMP_API.accountApiV1}/authenticate`, dt, {headers});
    }

    getUsers() {
        return this.http.get(`${SCAMP_API.accountApiV1}/users`, {headers: this.composeHeaders()});
    }

    getUsersById(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/users/${id}`, {headers: this.composeHeaders()});
    }

    create(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/users`, data, {headers: this.composeHeaders()});
    }

    update(data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/users/${data.id}`, data, {headers: this.composeHeaders()});
    }

    removeUser(data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/users/remove/${data.id}`, data, {headers: this.composeHeaders()});
    }
}
